// Pure routing decision for the "/" root route (EPIC-38, public homepage).
// Extracted out of `App.tsx` so the decision itself — not just its JSX
// wiring — is directly unit-testable without pulling in App.tsx's full
// module graph (every page in the route table), which is otherwise an
// expensive import in tests (see vite.config.ts's `maxWorkers` comment).
//
// The one behavior this exists to pin: an authenticated visitor to "/"
// must never see the marketing homepage, not even for one render — see
// `HomeRoute` in `App.tsx` for how the three outcomes below are rendered.
export type HomeRouteOutcome =
  | { kind: "loading" }
  | { kind: "redirect"; to: "/dashboard" | "/guest" }
  | { kind: "home" };

export interface HomeRouteUser {
  role?: "admin" | "analyst" | "guest";
}

export function resolveHomeRouteOutcome(
  user: HomeRouteUser | null,
  loading: boolean,
): HomeRouteOutcome {
  // Auth state hasn't resolved yet — render neither surface. This is what
  // keeps a signed-in user from ever seeing a flash of marketing content:
  // in production `authStore`'s `loading` starts `true` and only flips
  // once Firebase's `onAuthStateChanged` actually resolves.
  if (loading) {
    return { kind: "loading" };
  }

  if (user) {
    // Preserves the guest special-case a bare (no-allowedRoles)
    // `ProtectedRoute` used to apply when "/" was still nested under it.
    return {
      kind: "redirect",
      to: user.role === "guest" ? "/guest" : "/dashboard",
    };
  }

  return { kind: "home" };
}
